import PruningReasons from './PruningReasons/PruningReasons.vue';
import PruningCatching from './PruningCatching/PruningCatching.vue';
import PruningCatch from './PruningCatch/PruningCatch.vue';
import PruningMethods from './PruningMethods/Index.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';

const PruningsRoutes = {
  path: 'pruning',
  name: 'Poda',
  component: MasterTab,
  props: { reference: 'pruningTabs' },
  children: [
    {
      path: 'reasons',
      name: 'Poda',
      component: PruningReasons,
      meta: {
        prefix_permission: 'pruning_reasons',
      },
    },
    {
      path: 'catching',
      name: 'Poda',
      component: PruningCatching,
      meta: {
        prefix_permission: 'pruning_catching',
      },
    },
    {
      path: 'methods',
      name: 'Poda',
      component: PruningMethods,
      meta: {
        prefix_permission: 'pruning_methods',
      },
    },
    {
      path: 'catchs',
      name: 'Captura de Poda',
      component: PruningCatch,
      meta: {
        prefix_permission: 'pruning_catchs',
      },
    },
  ],
};

export default PruningsRoutes;
